import { productCarouselCards, sliderSettings } from './product-carousel.constants';
import { StyledCardImage, StyledCardImageContainer, StyledFadingEdges, StyledFeatureCard, StyledImageWrapper, StyledProductDescription, StyledProductTitle, StyledSectionGradientWrapper, StyledSlider, StyledWrapperInfo } from './product-carousel.styles';
export const ProductCarousel = () => {
  return <StyledSectionGradientWrapper data-sentry-element="StyledSectionGradientWrapper" data-sentry-component="ProductCarousel" data-sentry-source-file="product-carousel.tsx">
      <StyledFadingEdges data-sentry-element="StyledFadingEdges" data-sentry-source-file="product-carousel.tsx">
        <StyledSlider {...sliderSettings} data-sentry-element="StyledSlider" data-sentry-source-file="product-carousel.tsx">
          {productCarouselCards.map(product => <StyledFeatureCard key={product.name}>
              <StyledCardImageContainer>
                <StyledImageWrapper>
                  <StyledCardImage src={product.image} alt={product.name} />
                  <StyledWrapperInfo>
                    <StyledProductTitle>{product.name}</StyledProductTitle>
                    <StyledProductDescription>{product.description}</StyledProductDescription>
                  </StyledWrapperInfo>
                </StyledImageWrapper>
              </StyledCardImageContainer>
            </StyledFeatureCard>)}
        </StyledSlider>
      </StyledFadingEdges>
    </StyledSectionGradientWrapper>;
};